var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLanguageLearning(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9476_36046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9987 2.5H9.33203V5.83333H10.6654V3.83333H19.9987C20.3987 3.83333 20.6654 4.1 20.6654 4.5V11.8333C20.6654 12.2333 20.3987 12.5 19.9987 12.5H11.332V17.1667H7.7987L5.33203 19.1V17.1667H3.33203C2.93203 17.1667 2.66536 16.9 2.66536 16.5V9.16667C2.66536 8.76667 2.93203 8.5 3.33203 8.5H11.9987V7.16667H3.33203C2.1987 7.16667 1.33203 8.03333 1.33203 9.16667V16.5C1.33203 17.6333 2.1987 18.5 3.33203 18.5H3.9987V21.9L8.1987 18.5H12.6654V13.8333H19.9987C21.132 13.8333 21.9987 12.9667 21.9987 11.8333V4.5C21.9987 3.36667 21.132 2.5 19.9987 2.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13281 15.7693H5.73281L6.13281 14.7026H8.19948L8.59948 15.7693H10.1995L7.93281 9.83594H6.33281L4.13281 15.7693ZM7.13281 11.5026L7.79948 13.5693H6.46615L7.13281 11.5026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.332 11.8333C14.0654 11.8333 15.0654 11.6333 15.9987 11.1667C16.932 11.6333 17.9987 11.8333 18.6654 11.8333V10.5C18.6654 10.5 17.9987 10.5 17.2654 10.2333C18.0654 9.43333 18.6654 8.23333 18.6654 6.5V5.83333H16.6654V4.5H15.332V5.83333H13.332V7.16667H17.2654C17.132 8.36667 16.5987 9.1 15.9987 9.56667C15.5987 9.23333 15.1987 8.76667 14.932 8.16667H13.532C13.7987 9.03333 14.1987 9.7 14.732 10.2333C14.0654 10.5 13.4654 10.5 13.332 10.5V11.8333V11.8333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9476_36046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLanguageLearning);
export default __webpack_public_path__ + "static/media/icon-language-learning.a4a59bbe.svg";
export { ForwardRef as ReactComponent };